import React from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import { PaymentDecisionStep } from "../components/intake/PaymentDecisionStep";

export function Pricing() {
  const [email, setEmail] = React.useState("");
  const [ready, setReady] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;

    const run = async () => {
      // 1) Prefer email captured in the intake flow (works without login)
      const lsEmail =
        typeof window !== "undefined"
          ? (localStorage.getItem("niyyah_email") || "").trim().toLowerCase()
          : "";

      // 2) Fallback: session email (if user happens to be logged in)
      const { data } = await supabase.auth.getSession();
      const sessionEmail = (data.session?.user?.email || "").trim().toLowerCase();

      // Prefer intake email, else session email
      const resolved = lsEmail || sessionEmail;

      if (!cancelled) {
        setEmail(resolved);
        setReady(true);
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, []);

  // If we can't resolve an email, send them back to the intake start.
  // (This avoids "Missing email" and avoids landing on /login.)
  if (ready && !email) {
    return <Navigate to="/intake" replace />;
  }

  if (!ready) return null;

  return (
    <div className="min-h-screen bg-[#FDFCFE] text-[#2D2A35] font-sans">
      <div className="max-w-6xl mx-auto px-6 py-12 sm:py-20">
        <PaymentDecisionStep email={email} />
      </div>
    </div>
  );
}